import { Link, Stack } from "expo-router";
import { View } from "react-native";

import { AppText } from "@/components/ui/AppText";
import { useI18n } from "@/context/I18nContext";

export default function NotFoundScreen() {
  const { t } = useI18n();

  return (
    <>
      <Stack.Screen options={{ title: t("notFound.screenTitle") }} />
      <View className="flex-1 items-center justify-center bg-white p-6">
        <AppText weight="bold" className="text-6xl text-dark-text-50 mb-4">
          404
        </AppText>
        <AppText weight="semibold" className="text-xl text-dark-text-50 mb-2">
          {t("notFound.heading")}
        </AppText>
        <AppText weight="regular" className="text-sm text-supporting-text text-center mb-8">
          {t("notFound.description")}
        </AppText>
        <Link href="/" className="text-primary text-sm font-medium">
          {t("notFound.goHome")}
        </Link>
      </View>
    </>
  );
}
